import { atom } from "jotai";
/**
 * Atom for the base Path of the document generation.
 * TODO replace with context to get rid of jotai dependency
 */
export const docServerBasePath = atom("");
//# sourceMappingURL=docServerBasePath.js.map